import {default as React} from 'react';
import {RouteComponentProps} from 'react-router';
import {CameraScreen} from './screens/CameraScreen';
import {AlarmScreen} from './screens/AlarmScreen';
import {IntercomScreen} from './screens/IntercomScreen';
import {MediaCreateScreen} from './screens/MediaCreateScreen';
import {LoginScreen} from './screens/LoginScreen';
import {SettingsRoutes} from './screens/Settings';
import {MainScreen} from './screens/MainScreen';
import {UserSettingsScreen} from './screens/SettingsScreen/UserSettingsScreen';
import {ScenarioScreen} from './screens/ScenarioScreen';
import {SensorScreen} from './screens/SensorScreen';
import {PageScreen} from './screens/PageScreen';
import {MediaListScreen} from './screens/MediaListScreen';
import {ConciergeScreen} from './screens/ConciergeScreen';
import {MeetingScreen} from "./screens/MeetingScreen";
import {AreaScreen} from "./screens/AreaScreen";
import {IframeScreen} from "./screens/IframeScreen";
import {SliderScreen} from "./screens/Slider";
import {DigitalClock} from "./screens/DigitalClock";
import {AnalogClock} from "./screens/AnalogClock";
import ColorScreen from "./screens/ColorScreen";
import {EnergyScreen} from "./screens/EnergyScreen";

export type RouteDefinition = {
    routerLink?: string;
    exact?: boolean;
    component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
};

export const getRouteList = (): RouteDefinition[] => [
    {
        routerLink: '/',
        component: MainScreen,
        exact: true,
    },
    {
        routerLink: '/iframe',
        component: IframeScreen,
        exact: true,
    },
    {
        routerLink: '/energy',
        component: EnergyScreen,
        exact: true,
    },
    {
        routerLink: '/login',
        component: LoginScreen,
        exact: true,
    },
    {
        routerLink: '/intercom',
        component: IntercomScreen,
        exact: true,
    },
    {
        routerLink: '/area',
        component: AreaScreen,
        exact: true,
    },
    {
        routerLink: '/area/:id',
        component: AreaScreen,
        exact: true,
    },
    {
        routerLink: '/camera',
        component: CameraScreen,
        exact: true,
    },
    {
        routerLink: '/alarm',
        component: AlarmScreen,
        exact: true,
    },
    {
        routerLink: '/scenario',
        component: ScenarioScreen,
        exact: true,
    },
    {
        routerLink: '/sensor',
        component: SensorScreen,
        exact: true,
    },
    {
        routerLink: '/concierge',
        component: ConciergeScreen,
        exact: true,
    },
    {
        routerLink: '/meeting',
        component: MeetingScreen,
        exact: true,
    },
    {
        routerLink: '/media-remote/create',
        component: MediaCreateScreen,
        exact: true,
    },
    ...SettingsRoutes,
    {
        routerLink: '/settings',
        component: UserSettingsScreen,
        exact: true,
    },
    {
        routerLink: '/page/:id',
        component: PageScreen,
        exact: true,
    },
    {
        routerLink: '/media-remote',
        component: MediaListScreen,
        exact: true,
    },{
        routerLink: '/color-picker',
        component: ColorScreen,
        exact: true,
    },
    {
        routerLink: '/slider',
        component: SliderScreen,
        exact: true,
    },
    {
        routerLink: '/digital-clock',
        component: DigitalClock,
        exact: true,
    }, {
        routerLink: '/analog-clock',
        component: AnalogClock,
        exact: true,
    },
];
